import { render, staticRenderFns } from "./CommonSync.vue?vue&type=template&id=6a343e3b&"
import script from "./CommonSync.vue?vue&type=script&lang=js&"
export * from "./CommonSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports